(function ($) {
  DJ.addBehavior('contentTabs', '.content-tabs', {
    attach: function () {
      const contentTabs = this;
      const navigationBtn = contentTabs.querySelectorAll('.content-tabs__button');
      const navigationBtnActiveClass = 'content-tabs__button--active';
      const tabBody = contentTabs.querySelector('.content-tabs__body');
      const tabContent = tabBody.querySelectorAll('.content-tabs__tab');
      const tabContentHiddenClass = 'content-tabs__tab--hidden';
      const locationHash = window.location.hash;
      const currentButton = $(`a[href="${locationHash}"]`);

      const getUrlParameter = (name) => {
        const paramName = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
        const regex = new RegExp(`[?&]${paramName}=([^&#]*)`);
        const results = regex.exec(location.search);
        return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
      };

      const locationParam = getUrlParameter('tab');

      /**
       * Hide tabs when a script is fired.
       */
      $(tabContent).addClass(tabContentHiddenClass);

      /**
       * Open tab depending on location hash.
       * If it's empty or invalid, open the first tab.
       */
      if (locationHash && currentButton.length) {
        currentButton.addClass(navigationBtnActiveClass);
        $(tabBody).find(`.${locationHash.substring(1)}`).removeClass(tabContentHiddenClass);
      } else if (locationParam && $(`a[href="#${locationParam}"]`).length) {
        $(`a[href="#${locationParam}"]`).addClass(navigationBtnActiveClass);
        $(tabBody).find(`.${locationParam}`).removeClass(tabContentHiddenClass);
      } else {
        const href = $(navigationBtn[0]).attr('href');

        $(`a[href="${href}"]`).addClass(navigationBtnActiveClass);
        $(tabContent[0]).removeClass(tabContentHiddenClass);
      }

      /**
       * Open tab on button click
       */
      $(navigationBtn).on('click', function () {
        const $thisButton = jQuery(this);
        const href = $thisButton.attr('href');

        if (!($thisButton.hasClass(navigationBtnActiveClass))) {
          $(navigationBtn).removeClass(navigationBtnActiveClass);
          $thisButton.addClass(navigationBtnActiveClass);
          $(tabContent).addClass(tabContentHiddenClass);
          $(tabBody).find(`.${href.substring(1)}`).removeClass(tabContentHiddenClass);
          window.location.hash = href;

          // set equal height for resources elements when open a tab.
          if (DJ.behaviors && DJ.behaviors.resourcesFilter) {
            DJ.behaviors.resourcesFilter.setEqualHeightInit();
          }
        }

        return false;
      });
    }
  });
})(jQuery);
